import { CrossIcon, DiscardIcon } from "../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MuiPopup } from "../../../components";
import { mobilenoblack } from "../../../theme/palette";
export var DiscardPopup = function (props) {
    var openPopper = props.openPopper, handleClose = props.handleClose, onDiscardButtonClick = props.onDiscardButtonClick;
    var formData = [{
            type: FormItemTypes.IconButton,
            name: 'icon',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(DiscardIcon, {
                sx: {
                    fontSize: 48
                }
            }),
            columnSize: true
        }, {
            type: FormItemTypes.IconButton,
            name: 'close',
            label: '',
            value: null,
            children: /*#__PURE__*/ React.createElement(CrossIcon, {
                sx: {
                    fontSize: 20
                }
            }),
            onClick: handleClose,
            columnSize: 0
        }, {
            type: FormItemTypes.Typography,
            name: 'Msg',
            label: 'Are you sure you want to discard?',
            value: null,
            columnSize: 12,
            children: "Selecting discard will discard your current form.",
            labelTypographyProps: {
                fontSize: "18px",
                fontWeight: 600,
                lineHeight: "28px",
                color: mobilenoblack
            },
            variant: "h6",
            color: "#8593A3"
        }, {
            type: FormItemTypes.Button,
            name: 'cancel',
            label: '',
            value: null,
            children: 'Cancel',
            columnSize: 6,
            fullWidth: true,
            variant: 'outlined',
            size: 'small',
            sx: {
                py: 0.5,
                color: "#6A7682",
                border: '1px solid #DEE4EB',
                fontWeight: 500,
                fontSize: 14
            },
            onClick: handleClose
        }, {
            type: FormItemTypes.Button,
            name: 'discard',
            label: '',
            value: null,
            children: 'Discard',
            columnSize: 6,
            fullWidth: true,
            variant: 'contained',
            size: 'small',
            sx: {
                py: 0.5,
                color: "#FFFFFF",
                backgroundColor: "#F5222D",
                fontWeight: 500,
                fontSize: 14
            },
            onClick: onDiscardButtonClick
        }];
    return /*#__PURE__*/ React.createElement(MuiPopup, {
        id: "discard-popup",
        openPopup: openPopper,
        onClose: function () { return handleClose(); },
        closeIcon: false,
        backdropEnable: true
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData
    }));
};
